/* Dims shipping-bar message — externalized from sections/announcement-bar.liquid
   Reads config from #dims-shipping-bar-msg data-* attributes. Translations are
   pure JS literals; market/threshold/currency are set per-render via Liquid.

   10-09-2026 (ferie 10.-21. september):
   1) Leverings-USP'en i topbaren ("1-2 hverdages levering") erstattes af afsendelsesdatoen.
   2) Samme erstatning laves i produktsidens USP-tekstblok (.product--text) og i forsidens
      scrolling-text-baendel (.scrolling-text__item). Begge steder er teksten oversat pr.
      marked ("1-2 TAGE LIEFERUNG", "1-2 DAY DELIVERY", "Dostawa 1-2 dni" osv.), og
      oversaettelserne kan ikke redigeres fra temafilerne — derfor byttes de i JS ud fra
      moensteret ciffer-bindestreg-ciffer efterfulgt af et dagsord. "14 dages returret" /
      "14-DAY RETURNS" rammes ikke, fordi der kraeves et ciffer paa begge sider af stregen.
   Fri fragt- og Trustpilot-udsagn er uroerte. Fjern alle FERIE_*-blokke naar kampagnen
   tages ned — resten af filen er uaendret. */
(function () {
  var T = {
    'da': {
      dflt:   '✔️ Fragt fra 39,- og Gratis Fragt over {t}',
      below:  'Køb for {a} mere for Gratis Fragt',
      above:  '✔️ Tillykke – du har opnået Gratis Fragt!',
      noFree: '✔️ Billig fragt til Europa',
      suffix: '✔️ 1-2 hverdages levering ✔️ 4.9 / 5.0 på Trustpilot'
    },
    'en': {
      dflt:   '✔️ Shipping from €7.95 · Free shipping over {t}',
      below:  'Add {a} more for free shipping',
      above:  '✔️ Great – you’ve got free shipping!',
      noFree: '✔️ Cheap shipping to Europe',
      suffix: '✔️ 1-2 business days ✔️ 4.9 / 5.0 on Trustpilot'
    },
    'sv': {
      dflt:   '✔️ Frakt från 49 kr · Gratis frakt över {t}',
      below:  'Köp för {a} mer för Gratis Frakt',
      above:  '✔️ Grattis – du har uppnått Gratis Frakt!',
      noFree: '✔️ Billig frakt till Europa',
      suffix: '✔️ 1-2 vardagars leverans ✔️ 4,9 / 5,0 på Trustpilot'
    },
    'de': {
      dflt:   '✔️ Versand ab 7,95 € · Gratis Versand ab {t}',
      below:  'Noch {a} bis zum Gratisversand',
      above:  '✔️ Super – kostenloser Versand erzielt!',
      noFree: '✔️ Günstige Lieferung nach Europa',
      suffix: '✔️ 1-2 Werktage ✔️ 4,9 / 5,0 auf Trustpilot'
    },
    'fr': {
      dflt:   '✔️ Livraison dès 7,95 € · Livraison offerte dès {t}',
      below:  'Plus que {a} pour la livraison offerte',
      above:  '✔️ Super – vous bénéficiez de la livraison offerte !',
      noFree: '✔️ Livraison économique en Europe',
      suffix: '✔️ 1-2 jours ouvrés ✔️ 4,9 / 5,0 sur Trustpilot'
    },
    'nl': {
      dflt:   '✔️ Verzending vanaf €7,95 · Gratis verzending boven {t}',
      below:  'Nog {a} voor gratis verzending',
      above:  '✔️ Gefeliciteerd – gratis verzending bereikt!',
      noFree: '✔️ Voordelige verzending naar Europa',
      suffix: '✔️ 1-2 werkdagen ✔️ 4,9 / 5,0 op Trustpilot'
    },
    'it': {
      dflt:   '✔️ Spedizione da 7,95 € · Spedizione gratuita sopra {t}',
      below:  'Ancora {a} per la spedizione gratuita',
      above:  '✔️ Ottimo – spedizione gratuita raggiunta!',
      noFree: '✔️ Spedizione economica in Europa',
      suffix: '✔️ 1-2 giorni lavorativi ✔️ 4,9 / 5,0 su Trustpilot'
    },
    'es': {
      dflt:   '✔️ Envío desde 7,95 € · Envío gratis a partir de {t}',
      below:  'Faltan {a} para el envío gratis',
      above:  '✔️ ¡Genial – envío gratis conseguido!',
      noFree: '✔️ Envío económico a Europa',
      suffix: '✔️ 1-2 días hábiles ✔️ 4,9 / 5,0 en Trustpilot'
    },
    'pl': {
      dflt:   '✔️ Dostawa od 7,95 € · Darmowa dostawa powyżej {t}',
      below:  'Jeszcze {a} do darmowej dostawy',
      above:  '✔️ Świetnie – darmowa dostawa!',
      noFree: '✔️ Tania wysyłka do Europy',
      suffix: '✔️ 1-2 dni robocze ✔️ 4,9 / 5,0 na Trustpilot'
    },
    'fi': {
      dflt:   '✔️ Toimitus alkaen 7,95 € · Ilmainen toimitus yli {t}',
      below:  'Lisää {a} ilmaiseen toimitukseen',
      above:  '✔️ Hienoa – ilmainen toimitus!',
      noFree: '✔️ Edullinen toimitus Eurooppaan',
      suffix: '✔️ 1-2 arkipäivää  ✔️ Hintavertailu  ✔️ 4,9 / 5,0 Trustpilotissa'
    },
    'ro': {
      dflt:   '✔️ Livrare de la 7,95 € · Livrare gratuită de la {t}',
      below:  'Mai adaugă {a} pentru livrare gratuită',
      above:  '✔️ Felicitări – ai livrare gratuită!',
      noFree: '✔️ Livrare ieftină în Europa',
      suffix: '✔️ 1-2 zile lucrătoare ✔️ 4,9 / 5,0 pe Trustpilot'
    },
    'cs': {
      dflt:   '✔️ Doprava od 7,95 € · Doprava zdarma nad {t}',
      below:  'Do dopravy zdarma zbývá {a}',
      above:  '✔️ Skvěle – doprava zdarma!',
      noFree: '✔️ Levné doručení do Evropy',
      suffix: '✔️ 1-2 pracovní dny ✔️ 4,9 / 5,0 na Trustpilot'
    },
    'no': {
      dflt:   '✔️ Frakt fra 49 kr · Gratis frakt over {t}',
      below:  'Kjøp for {a} mer for Gratis Frakt',
      above:  '✔️ Flott – du har oppnådd Gratis Frakt!',
      noFree: '✔️ Billig frakt til Europa',
      suffix: '✔️ 1-2 virkedager ✔️ 4,9 / 5,0 på Trustpilot'
    }
  };

  /* ---------- Ferie 10.-21. september 2026 (dansk tid, CEST = UTC+2) ---------- */
  var FERIE_START = Date.UTC(2026, 8, 9, 22, 0, 0);   /* 10/9 kl. 00:00 */
  var FERIE_END   = Date.UTC(2026, 8, 21, 22, 0, 0);  /* 22/9 kl. 00:00 */

  /* Kun afsendelsesdatoen — bruges i produktsidens USP-liste og i forsidens baendel */
  var FERIE_SHIP = {
    'da': '📦 Sendes tirsdag d. 22. september',
    'en': '📦 Ships Tuesday 22 September',
    'sv': '📦 Skickas tisdag den 22 september',
    'de': '📦 Versand am Dienstag, den 22. September',
    'fr': '📦 Expédition le mardi 22 septembre',
    'nl': '📦 Verzending dinsdag 22 september',
    'it': '📦 Spedizione martedì 22 settembre',
    'es': '📦 Envío el martes 22 de septiembre',
    'pl': '📦 Wysyłka we wtorek 22 września',
    'fi': '📦 Lähetys tiistaina 22. syyskuuta',
    'ro': '📦 Expediere marți, 22 septembrie',
    'cs': '📦 Odesíláme v úterý 22. září',
    'no': '📦 Sendes tirsdag 22. september'
  };

  /* Samme, uden emoji — forsidens baendel har ingen ikoner */
  var FERIE_SHIP_PLAIN = {
    'da': 'Ordrer sendes tirsdag d. 22. september',
    'en': 'Orders ship Tuesday 22 September',
    'sv': 'Beställningar skickas tisdag den 22 september',
    'de': 'Versand am Dienstag, den 22. September',
    'fr': 'Expédition le mardi 22 septembre',
    'nl': 'Bestellingen worden dinsdag 22 september verzonden',
    'it': 'Ordini spediti martedì 22 settembre',
    'es': 'Los pedidos se envían el martes 22 de septiembre',
    'pl': 'Zamówienia wysyłamy we wtorek 22 września',
    'fi': 'Tilaukset lähetetään tiistaina 22. syyskuuta',
    'ro': 'Comenzile se expediază marți, 22 septembrie',
    'cs': 'Objednávky odesíláme v úterý 22. září',
    'no': 'Bestillinger sendes tirsdag 22. september'
  };

  /* Afsendelsesdato + Trustpilot — bruges i topbaren */
  var FERIE_SUFFIX = {
    'da': '✔️ Sendes tirsdag d. 22. september ✔️ 4.9 / 5.0 på Trustpilot',
    'en': '✔️ Ships Tuesday 22 September ✔️ 4.9 / 5.0 on Trustpilot',
    'sv': '✔️ Skickas tisdag den 22 september ✔️ 4,9 / 5,0 på Trustpilot',
    'de': '✔️ Versand am Dienstag, den 22. September ✔️ 4,9 / 5,0 auf Trustpilot',
    'fr': '✔️ Expédition le mardi 22 septembre ✔️ 4,9 / 5,0 sur Trustpilot',
    'nl': '✔️ Verzending dinsdag 22 september ✔️ 4,9 / 5,0 op Trustpilot',
    'it': '✔️ Spedizione martedì 22 settembre ✔️ 4,9 / 5,0 su Trustpilot',
    'es': '✔️ Envío el martes 22 de septiembre ✔️ 4,9 / 5,0 en Trustpilot',
    'pl': '✔️ Wysyłka we wtorek 22 września ✔️ 4,9 / 5,0 na Trustpilot',
    'fi': '✔️ Lähetys tiistaina 22. syyskuuta ✔️ 4,9 / 5,0 Trustpilotissa',
    'ro': '✔️ Expediere marți, 22 septembrie ✔️ 4,9 / 5,0 pe Trustpilot',
    'cs': '✔️ Odesíláme v úterý 22. září ✔️ 4,9 / 5,0 na Trustpilot',
    'no': '✔️ Sendes tirsdag 22. september ✔️ 4,9 / 5,0 på Trustpilot'
  };

  /* Ciffer-bindestreg-ciffer efterfulgt af et dagsord. Rammer "1-2 dages levering",
     "1-2 TAGE LIEFERUNG", "1-2 DAY DELIVERY", "Dostawa 1-2 dni", "1-2 jours" osv.
     Rammer IKKE "14 dages returret" / "14-DAY RETURNS", da der skal staa et ciffer
     paa begge sider af bindestregen. */
  var FERIE_DAYS_RE = /\d\s*[-–]\s*\d\s*(hverdag|dage|dagar|dager|virkedag|tage|werktag|day|jour|werkdag|giorni|d[ií]a|dni|arkip[aä]iv|p[aä]iv|pracovn|dny|zile)/i;

  function inFerie() {
    var t = Date.now();
    return t >= FERIE_START && t < FERIE_END;
  }

  function swapIn(scope, line) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (FERIE_DAYS_RE.test(node.nodeValue)) {
        node.nodeValue = line;
      }
    }
  }

  /* Erstat leveringstids-loeftet i produktsidens USP-blok og i forsidens baendel.
     Baendlet klones af temaets marquee, saa den koeres igen efter load. */
  function ferieSwapDeliveryClaims(lang) {
    var withIcon = FERIE_SHIP[lang] || FERIE_SHIP['en'];
    var plain    = FERIE_SHIP_PLAIN[lang] || FERIE_SHIP_PLAIN['en'];

    Array.prototype.forEach.call(
      document.querySelectorAll('.product-information--inner .product--text'),
      function (el) { swapIn(el, withIcon); }
    );
    Array.prototype.forEach.call(
      document.querySelectorAll('.scrolling-text__item'),
      function (el) { swapIn(el, plain); }
    );
  }

  var FMT = {
    'DKK': function(c) { return Math.ceil(c / 100).toLocaleString('da-DK') + ' kr.'; },
    'SEK': function(c) { return Math.ceil(c / 100).toLocaleString('sv-SE') + ' kr.'; },
    'EUR': function(c) { return Math.ceil(c / 100).toLocaleString('de-DE') + ' €'; },
    'PLN': function(c) { return Math.ceil(c / 100).toLocaleString('pl-PL') + ' zł'; },
    'CZK': function(c) { return Math.ceil(c / 100).toLocaleString('cs-CZ') + ' Kč'; },
    'RON': function(c) { return Math.ceil(c / 100).toLocaleString('ro-RO') + ' lei'; }
  };

  function run() {
    var lang = (document.documentElement.lang || 'da').split('-')[0].toLowerCase();
    var ferie = inFerie();

    if (ferie) {
      ferieSwapDeliveryClaims(lang);
      window.addEventListener('load', function () { ferieSwapDeliveryClaims(lang); });
      setTimeout(function () { ferieSwapDeliveryClaims(lang); }, 1500);
    }

    var el = document.getElementById('dims-shipping-bar-msg');
    if (!el) return;

    var threshold  = parseFloat(el.dataset.threshold  || '0') * 100;
    var currency   = el.dataset.currency   || 'DKK';
    var noFree     = el.dataset.noFree     === 'true';
    var threshDisp = el.dataset.thresholdDisplay || '';

    var tr   = T[lang] || T['en'];
    var fmt  = FMT[currency] || FMT['DKK'];

    var trSuffix = tr.suffix || '';
    if (ferie) {
      trSuffix = FERIE_SUFFIX[lang] || FERIE_SUFFIX['en'];
    }
    var sep = trSuffix ? ' <span class="dims-bar-sep">·</span> ' + trSuffix : '';

    function update(totalCents) {
      var html;
      if (noFree || threshold <= 0) {
        html = tr.noFree;
      } else if (totalCents <= 0) {
        html = tr.dflt.replace('{t}', threshDisp);
      } else if (totalCents >= threshold) {
        html = tr.above;
      } else {
        html = tr.below.replace('{a}', fmt(threshold - totalCents));
      }
      el.innerHTML = html + sep;
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(c) { update(c.total_price); })
      .catch(function()  { update(0); });

    document.addEventListener('cart:refresh', function() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });
    document.addEventListener('cart:updated', function(e) {
      if (e.detail && e.detail.cart) update(e.detail.cart.total_price);
      else fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
